import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import wechat from '@/utils/wechat.js'

// 在入口文件中（main.js），导入组件库
import vueHashCalendar from 'vue-hash-calendar'
// 引入组件CSS样式
import 'vue-hash-calendar/lib/vue-hash-calendar.css'

// 注册组件库
Vue.use(vueHashCalendar)

require('amfe-flexible')
import '@/plugins/vant'
import '@vant/touch-emulator'

Object.assign(Vue.prototype, {
  $wechat: wechat
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
